import { useQuery } from '@tanstack/react-query'
import { idleKey, type IdleEverywhere } from './everywhere'
import type { AgentRow } from '../transport/api'

/**
 * WHAT THE APP ALREADY KNOWS ABOUT ONE AGENT'S CONVERSATION, as a string that changes
 * when any of it does — the Clean View's second opinion (owner, 2026-10-04: Clean View
 * 跟不上 Terminal 的內容, 停止在某一個時間點不再更新).
 *
 * The rail's busy dot and its "last said / last asked" line come over the account
 * stream. Clean View's own updates come from a file watch on its headless socket. When
 * that watch dies the rail goes on moving and the conversation stands still — two
 * surfaces answering one question from two sources, and only one of them right. This
 * hands the rail's facts to the view as a pulse: when it changes, the view re-reads.
 *
 * READS THE CACHE, ASKS NOTHING. `enabled: false` subscribes to the one `idle-status`
 * query useIdleStatus owns and fills; no request is ever made from here.
 *
 * AND RENDERS ONLY WHEN THIS AGENT MOVED. The cache is rewritten every time ANY machine
 * of the account reports — several times a second on a busy account — and the component
 * holding this hook draws a thousand blocks. `select` narrows the subscription to this
 * agent's two timestamps, so everyone else's activity costs this view nothing.
 */
export function useAgentPulse(agent: AgentRow, working: boolean | undefined): string {
  const key = idleKey(agent)
  const q = useQuery<IdleEverywhere, Error, string>({
    queryKey: ['idle-status'],
    enabled: false,
    select: (d) => {
      const row = d.agents.find((a) => idleKey(a) === key)
      return `${row?.last_said_ts ?? ''}|${row?.last_ask_ts ?? ''}`
    },
  })
  return `${working ? 1 : 0}|${q.data ?? '|'}`
}
